import type { KioskAlert } from './types';

type Translate = (key: string, options?: any) => string;

export const when = (iso: string | null): string => (iso === null ? '-' : new Date(iso).toLocaleString());

export const detailValue = (value: unknown): string => {
  if (value === null) return '-';
  return typeof value === 'object' ? JSON.stringify(value) : String(value);
};

export const kioskAlertsLink = (filter: Record<string, string>): string => `/kiosk-alerts?filter=${encodeURIComponent(JSON.stringify(filter))}`;

export function handledLine(record: KioskAlert, translate: Translate): string {
  if (record.handledAt !== null) {
    return translate('resources.kiosk-alerts.handledBy', { name: record.handledByName === null ? record.handledBy : record.handledByName, time: when(record.handledAt) });
  }
  if (record.clearedAt !== null) return translate('resources.kiosk-alerts.clearedAt', { time: when(record.clearedAt) });
  return '-';
}
